import { Extension } from '@tiptap/core';
import { convertTypedFieldTokenAtCursor } from './fieldTokenEditorUtils';

export const FieldTokenAutoDetect = Extension.create({
  name: 'fieldTokenAutoDetect',

  addOptions() {
    return {
      getEnsureField: () => null,
    };
  },

  addKeyboardShortcuts() {
    return {
      Space: ({ editor }) => {
        const ensureField = this.options.getEnsureField?.();
        if (!ensureField) return false;

        const converted = convertTypedFieldTokenAtCursor(editor, ensureField);
        if (!converted) return false;

        editor.commands.insertContent(' ');
        return true;
      },
      Enter: ({ editor }) => {
        const ensureField = this.options.getEnsureField?.();
        if (!ensureField) return false;

        if (!convertTypedFieldTokenAtCursor(editor, ensureField)) {
          return false;
        }

        return editor.commands.splitBlock().run();
      },
    };
  },
});

export default FieldTokenAutoDetect;
